import { c as _c } from "react/compiler-runtime";
import { BodyLong } from "@navikt/ds-react";
import type { Unntak, UnntakArsaker } from "@/schema/aktivitetskravVurderingSchema";
const getAarsakAvsnitt = (arsak: UnntakArsaker) => {
  switch (arsak) {
    case "MEDISINSKE_GRUNNER":
      return "NAV har vurdert aktivitetsplikten din og besluttet at du er unntatt fra aktivitetsplikten på grunn av medisinske opplysninger.";
    case "TILRETTELEGGING_IKKE_MULIG":
      return "NAV har vurdert aktivitetsplikten din og besluttet at du er unntatt fra aktivitetsplikten siden tilrettelegging på arbeidsplassen ikke er mulig.";
    case "SJOMENN_UTENRIKS":
      return "NAV vurderer at du er unntatt fra aktivitetsplikten.";
  }
};
interface Props {
  vurdering: Unntak;
}
export const VurderingUnntak = t0 => {
  const $ = _c(4);
  const {
    vurdering
  } = t0;
  let t1;
  if ($[0] !== vurdering.arsaker[0]) {
    t1 = getAarsakAvsnitt(vurdering.arsaker[0]);
    $[0] = vurdering.arsaker[0];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <BodyLong className="font-bold">{t1}</BodyLong>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};